import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row w-100" }
const _hoisted_2 = { class: "card-body w-50" }
const _hoisted_3 = { class: "card-body w-50" }
const _hoisted_4 = { class: "pb-10 pb-lg-15" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<h2 class=\"fw-bolder d-flex align-items-center text-dark mb-6\"> Subject Characteristics <i class=\"fas fa-exclamation-circle ms-2 fs-7\" data-bs-toggle=\"tooltip\" title=\"Subject Characteristics\"></i></h2><div class=\"mb-6\"><label class=\"fs-6 fw-bold\"> 1. Will any vulnerable populations be targeted to participate in your study? </label></div><div class=\"text-gray-400 fw-bold mb-6 fs-6\"> Check all that applicable . </div>", 3)
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "row mb-6" }
const _hoisted_10 = { class: "col-lg-7 fv-row" }
const _hoisted_11 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Pregnant Individuals/Fetuses ")
], -1)
const _hoisted_13 = { class: "col-lg-5 fv-row" }
const _hoisted_14 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Prisoners ")
], -1)
const _hoisted_16 = { class: "row mb-6" }
const _hoisted_17 = { class: "col-lg-7 fv-row" }
const _hoisted_18 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Children (anyone under the age of 18) ")
], -1)
const _hoisted_20 = { class: "col-lg-5 fv-row" }
const _hoisted_21 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Individuals with cognitive impairments ")
], -1)
const _hoisted_23 = { class: "row mb-6" }
const _hoisted_24 = { class: "col-lg-7 fv-row" }
const _hoisted_25 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, " Economically Disadvantaged ")
], -1)
const _hoisted_27 = { class: "col-lg-5 fv-row" }
const _hoisted_28 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Minority Group(s) and Non-English Speakers ")
], -1)
const _hoisted_30 = { class: "row mb-6" }
const _hoisted_31 = { class: "col-lg-7 fv-row" }
const _hoisted_32 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Elderly Subjects (65+) ")
], -1)
const _hoisted_34 = { class: "col-lg-5 fv-row" }
const _hoisted_35 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Educationally Disadvantaged")
], -1)
const _hoisted_37 = { class: "row mb-6" }
const _hoisted_38 = { class: "col-lg-7 fv-row" }
const _hoisted_39 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Gannon University Students or Employees ")
], -1)
const _hoisted_41 = { class: "col-lg-5 fv-row" }
const _hoisted_42 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Individuals with Terminal Illness")
], -1)
const _hoisted_44 = { class: "row mb-6" }
const _hoisted_45 = { class: "col-lg-7 fv-row" }
const _hoisted_46 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0 me-3" }, "Other ")
], -1)
const _hoisted_48 = {
  key: 0,
  class: "col-lg-5 fv-row"
}
const _hoisted_49 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Other")
], -1)
const _hoisted_51 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-6" }, " 2. Which of the following best describe your subject (Checkboxes of the following): ", -1)
const _hoisted_52 = { class: "card-body" }
const _hoisted_53 = { class: "row mb-6" }
const _hoisted_54 = { class: "col-lg-7 fv-row" }
const _hoisted_55 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Inpatients (e.g., Hospital setting, inpatient rehabilitation)")
], -1)
const _hoisted_57 = { class: "col-lg-5 fv-row" }
const _hoisted_58 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Residential Facilities (e.g., Assisted living, long term nursing home facility)")
], -1)
const _hoisted_60 = { class: "row mb-6" }
const _hoisted_61 = { class: "col-lg-7 fv-row" }
const _hoisted_62 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Not applicable ")
], -1)
const _hoisted_64 = {
  key: 0,
  class: "col-lg-5 fv-row"
}
const _hoisted_65 = { class: "form-check form-check-custom form-check-solid align-items-start" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("span", { class: "form-check-label d-flex flex-column align-items-start" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fw-bolder fs-5 mb-0" }, "Single subject populations")
], -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DropDownSection = _resolveComponent("DropDownSection")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_DropDownSection, {
        title: "Review for more information",
        list: _ctx.listDropDownSections
      }, null, 8, ["list"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_1",
                  value: "1",
                  modelValue: _ctx.step2.q2_1,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.step2.q2_1) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_12
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("label", _hoisted_14, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_2",
                  value: "1",
                  modelValue: _ctx.step2.q2_2,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.step2.q2_2) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_15
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_3",
                  value: "1",
                  modelValue: _ctx.step2.q2_3,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.step2.q2_3) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_19
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("label", _hoisted_21, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_4",
                  value: "1",
                  modelValue: _ctx.step2.q2_4,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.step2.q2_4) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_22
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("label", _hoisted_25, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_5",
                  value: "1",
                  modelValue: _ctx.step2.q2_5,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.step2.q2_5) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_26
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_6",
                  value: "1",
                  modelValue: _ctx.step2.q2_6,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.step2.q2_6) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_29
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_7",
                  value: "1",
                  modelValue: _ctx.step2.q2_7,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.step2.q2_7) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_33
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createElementVNode("label", _hoisted_35, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_11",
                  value: "1",
                  modelValue: _ctx.step2.q2_11,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.step2.q2_11) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_36
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", _hoisted_39, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_12",
                  value: "1",
                  modelValue: _ctx.step2.q2_12,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.step2.q2_12) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_40
              ])
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("label", _hoisted_42, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_13",
                  value: "1",
                  modelValue: _ctx.step2.q2_13,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.step2.q2_13) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_43
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_44, [
            _createElementVNode("div", _hoisted_45, [
              _createElementVNode("label", _hoisted_46, [
                _hoisted_47,
                _createVNode(_component_Field, {
                  class: "form-control form-control-solid me-3",
                  type: "text",
                  name: "q2_populationOther",
                  value: "",
                  modelValue: _ctx.step2.q2_populationOther,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.step2.q2_populationOther) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("label", _hoisted_49, [
                    _createVNode(_component_Field, {
                      class: "form-check-input me-3",
                      type: "text",
                      name: "q2_populationOther",
                      value: "",
                      modelValue: _ctx.step2.q2_populationOther,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.step2.q2_populationOther) = $event))
                    }, null, 8, ["modelValue"]),
                    _hoisted_50
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _hoisted_51,
        _createElementVNode("div", _hoisted_52, [
          _createElementVNode("div", _hoisted_53, [
            _createElementVNode("div", _hoisted_54, [
              _createElementVNode("label", _hoisted_55, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_8",
                  value: "1",
                  modelValue: _ctx.step2.q2_8,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.step2.q2_8) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_56
              ])
            ]),
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("label", _hoisted_58, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_9",
                  value: "1",
                  modelValue: _ctx.step2.q2_9,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.step2.q2_9) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_59
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_60, [
            _createElementVNode("div", _hoisted_61, [
              _createElementVNode("label", _hoisted_62, [
                _createVNode(_component_Field, {
                  class: "form-check-input me-3",
                  type: "checkbox",
                  name: "q2_10",
                  value: "1",
                  modelValue: _ctx.step2.q2_10,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.step2.q2_10) = $event))
                }, null, 8, ["modelValue"]),
                _hoisted_63
              ])
            ]),
            false
              ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                  _createElementVNode("label", _hoisted_65, [
                    _createVNode(_component_Field, {
                      class: "form-check-input me-3",
                      type: "checkbox",
                      name: "p10",
                      value: "1"
                    }),
                    _hoisted_66
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_67
        ])
      ])
    ])
  ]))
}